import { createStore } from 'vuex'

import sideMenuModule from '@/store/modules/side-menu/index'
import darkModeModule from '@/store/modules/dark-mode/index'

import authModule from '@/store/modules/auth/index'

import activityLogModule from '@/store/modules/activityLog'
import analyticsModule from '@/store/modules/analytics'
import accountingCodeModule from '@/store/modules/settings/invoicing/accountingCode'
import accountingDiaryModule from '@/store/modules/settings/invoicing/accountingDiary'
import AddressModule from '@/store/modules/address/index'
import AgendaModule from '@/store/modules/agenda/index'
import automationModule from '@/store/modules/automation/index'
import bankAccountModule from '@/store/modules/settings/invoicing/bankAccount/index'
import chatModule from '@/store/modules/chat/index'
import commentsModule from '@/store/modules/comments/index'
import condolenceModule from '@/store/modules/condolence/index'
import companyModule from '@/store/modules/settings/corporation/company/index'
import contactModule from '@/store/modules/contact/index'
import dashboardModule from '@/store/modules/dashboard/index'
import documentModule from '@/store/modules/document/index'
import docVariableModule from '@/store/modules/settings/management/docVariable'
import dossierModule from '@/store/modules/dossiers/index'
import duplicateModelModule from '@/store/modules/settings/corporation/duplicateModel'
import electronicSignatureModule from '@/store/modules/electronicSignature/index'
import emailModule from '@/store/modules/email/index'
import funeralHomeModule from '@/store/modules/settings/corporation/funeralHome/index'
import funeralManagerModule from '@/store/modules/funeralManager/index'
import globalSearchModule from '@/store/modules/global_search/index'
import invoicingCategoryModule from '@/store/modules/settings/invoicing/invoicingCategory/index'
import invoicingModule from '@/store/modules/invoicing/index'
import itemCategoryModule from '@/store/modules/settings/invoicing/itemCategory/index'
import itemListModule from '@/store/modules/settings/general/itemList/index'
import itemModule from '@/store/modules/settings/invoicing/item/index'
import ListItemModule from '@/store/modules/settings/management/ListItem'
import locationModule from '@/store/modules/settings/corporation/location/index'
import materialResourceModule from '@/store/modules/settings/corporation/materialResource/index'
import messageTextModule from '@/store/modules/settings/management/messageText/index'
import marketplaceModule from '@/store/modules/marketplace/index'
import paymentModeModule from '@/store/modules/settings/invoicing/paymentMode/index'
import roleModule from '@/store/modules/settings/management/role/index'
import surveyModule from '@/store/modules/settings/management/survey/index'
import screenSettingsModule from '@/store/modules/settings/management/screenSettings/index'
import metadataModule from '@/store/modules/metadata/index'
import noteModule from '@/store/modules/note/index'
import notificationModule from '@/store/modules/notification/index'
import notificationSettingsModule from '@/store/modules/settings/general/notification/index'
import packModule from '@/store/modules/settings/invoicing/pack/index'
import PlanningModule from '@/store/modules/planning/index'
import PartnerModule from '@/store/modules/partner/index'
import saManagementModule from '@/store/modules/SAManagement/index'
import screenModule from '@/store/modules/screen/index'
import settingsModule from '@/store/modules/settings/index'
import siteModule from '@/store/modules/settings/corporation/site/index'
import statisticsModule from '@/store/modules/settings/general/statistics/index'
import supplierModule from '@/store/modules/supplier/index'
import supplierOrderModule from '@/store/modules/supplierOrder/index'
import scheduledTaskModule from '@/store/modules/scheduledTask/index'
import taskDossierModule from '@/store/modules/taskDossier/index'
import taskModule from '@/store/modules/settings/management/task/index'
import userModule from '@/store/modules/settings/user/index'
import versionNoteModule from '@/store/modules/settings/versionNote'
import wikiModule from '@/store/modules/wiki/index'
import modelNotificationModule from '@/store/modules/modelNotification/index'
import modelActivityModule from '@/store/modules/modelActivity/index'
import mediaModule from '@/store/modules/media/index'
import dossierNumberingModule from '@/store/modules/settings/general/dossierNumbering'
import gravePlotModule from '@/store/modules/gravePlot'
import personModule from '@/store/modules/person'
import stockModule from '@/store/modules/stock'
import UnavailabilityModule from '@/store/modules/unavailability'
import viewFiltersStateModule from './modules/viewFiltersState/index'
import impersonationModule from './modules/impersonation/index'
import vatModule from '@/store/modules/vat/index'

// const dataState = createPersistedState({
//   paths: ['auth', 'sessionExpiration', 'settings.systemSettings']
// })

const store = createStore({
  modules: {
    activityLog: activityLogModule,
    analytics: analyticsModule,
    accountingCode: accountingCodeModule,
    accountingDiary: accountingDiaryModule,
    dossierNumbering: dossierNumberingModule,
    condolence: condolenceModule,
    address: AddressModule,
    agenda: AgendaModule,
    auth: authModule,
    automation: automationModule,
    role: roleModule,
    paymentMode: paymentModeModule,
    survey: surveyModule,
    screenSettings: screenSettingsModule,
    bankAccount: bankAccountModule,
    chat: chatModule,
    comments: commentsModule,
    company: companyModule,
    contact: contactModule,
    darkMode: darkModeModule,
    dashboard: dashboardModule,
    document: documentModule,
    docVariable: docVariableModule,
    dossier: dossierModule,
    duplicateModel: duplicateModelModule,
    electronicSignature: electronicSignatureModule,
    email: emailModule,
    funeralManager: funeralManagerModule,
    funeralHome: funeralHomeModule,
    gravePlot: gravePlotModule,
    globalSearch: globalSearchModule,
    // i18n: i18nModule,
    invoicing: invoicingModule,
    invoicingCategory: invoicingCategoryModule,
    item: itemModule,
    itemCategory: itemCategoryModule,
    itemList: itemListModule,
    listItem: ListItemModule,
    location: locationModule,
    materialResource: materialResourceModule,
    marketplace: marketplaceModule,
    media: mediaModule,
    messageText: messageTextModule,
    metadata: metadataModule,
    modelNotification: modelNotificationModule,
    modelActivity: modelActivityModule,
    note: noteModule,
    notification: notificationModule,
    notificationSettings: notificationSettingsModule,
    pack: packModule,
    planning: PlanningModule,
    partner: PartnerModule,
    person: personModule,
    saManagement: saManagementModule,
    screen: screenModule,
    settings: settingsModule,
    sideMenu: sideMenuModule,
    site: siteModule,
    statistics: statisticsModule,
    stock: stockModule,
    supplier: supplierModule,
    supplierOrder: supplierOrderModule,
    scheduledTask: scheduledTaskModule,
    task: taskModule,
    taskDossier: taskDossierModule,
    user: userModule,
    versionNote: versionNoteModule,
    wiki: wikiModule,
    unavailability: UnavailabilityModule,
    viewFiltersState: viewFiltersStateModule,
    impersonation: impersonationModule,
    vat: vatModule,
  }
})

export function useStore() {
  return store
}

export default store
